/**
 * @generated SignedSource<<c82cd73acfdaf3e6bf5bd66c88691ed8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AgenticWorkerResultState = "NEEDS_REVIEW" | "DONE" | "DELETED" | "%future added value";
export type AgenticWorkerRowType = "PROJECT_BILLING_ROW" | "RETAINER_PERIOD_ROW" | "%future added value";
export type AgenticWorkerRunState = "RUNNING" | "STOPPED" | "NOTHING_FOUND" | "PRODUCED" | "FAILED" | "NOT_STARTED" | "%future added value";
export type AgenticWorkerRunStateReason = "ALREADY_RUNNING" | "TIMED_OUT" | "EXECUTOR_ERROR" | "%future added value";
export type AgenticWorkerScopeKind = "PAGE" | "ROW" | "%future added value";
export type agentRunStateSettleQuery$variables = {
  agentId: string;
  runId: string;
};
export type agentRunStateSettleQuery$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly agenticWorker: {
      readonly activeRuns: ReadonlyArray<{
        readonly id: string;
        readonly scopeKind: AgenticWorkerScopeKind;
        readonly scopeRowType: AgenticWorkerRowType | null;
        readonly scopeRowId: number | null;
        readonly state: AgenticWorkerRunState;
        readonly rows: ReadonlyArray<{
          readonly rowType: AgenticWorkerRowType;
          readonly rowId: number;
        }>;
      }>;
      readonly lastRun: {
        readonly id: string;
        readonly scopeKind: AgenticWorkerScopeKind;
        readonly scopeRowType: AgenticWorkerRowType | null;
        readonly scopeRowId: number | null;
        readonly state: AgenticWorkerRunState;
        readonly rows: ReadonlyArray<{
          readonly rowType: AgenticWorkerRowType;
          readonly rowId: number;
        }>;
        readonly stateReason: AgenticWorkerRunStateReason | null;
        readonly foundDetail: string | null;
        readonly finishedAt: string | null;
      } | null;
      readonly waitingResults: ReadonlyArray<{
        readonly id: string;
        readonly runId: string;
        readonly rows: ReadonlyArray<{
          readonly rowType: AgenticWorkerRowType;
          readonly rowId: number;
          readonly project: {
            readonly companyProjectId: number | null;
            readonly customProjectId: string | null;
            readonly name: string | null;
            readonly projectColor: string | null;
          } | null;
        }>;
        readonly state: AgenticWorkerResultState;
        readonly hidden: boolean;
        readonly producedAt: string | null;
      }>;
      readonly run: {
        readonly id: string;
        readonly scopeKind: AgenticWorkerScopeKind;
        readonly scopeRowType: AgenticWorkerRowType | null;
        readonly scopeRowId: number | null;
        readonly state: AgenticWorkerRunState;
        readonly rows: ReadonlyArray<{
          readonly rowType: AgenticWorkerRowType;
          readonly rowId: number;
        }>;
        readonly stateReason: AgenticWorkerRunStateReason | null;
        readonly foundDetail: string | null;
        readonly finishedAt: string | null;
      } | null;
    } | null;
  } | null;
};
export type agentRunStateSettleQuery = {
  variables: agentRunStateSettleQuery$variables;
  response: agentRunStateSettleQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "runId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "agentId",
    "variableName": "agentId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scopeKind",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scopeRowType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scopeRowId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "AgenticWorkerResultRow",
  "kind": "LinkedField",
  "name": "rows",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "AgenticWorkerRun",
  "kind": "LinkedField",
  "name": "activeRuns",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "stateReason",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "foundDetail",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "finishedAt",
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "AgenticWorkerRun",
  "kind": "LinkedField",
  "name": "lastRun",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "runId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hidden",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "producedAt",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "runId"
    }
  ],
  "concreteType": "AgenticWorkerRun",
  "kind": "LinkedField",
  "name": "run",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "agentRunStateSettleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "AgenticWorker",
            "kind": "LinkedField",
            "name": "agenticWorker",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AgenticWorkerResult",
                "kind": "LinkedField",
                "name": "waitingResults",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgenticWorkerResultRow",
                    "kind": "LinkedField",
                    "name": "rows",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              (v21/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "agentRunStateSettleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "AgenticWorker",
            "kind": "LinkedField",
            "name": "agenticWorker",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AgenticWorkerResult",
                "kind": "LinkedField",
                "name": "waitingResults",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgenticWorkerResultRow",
                    "kind": "LinkedField",
                    "name": "rows",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ee8e4afdafe951e5a2c9c4ec1b677224",
    "id": null,
    "metadata": {},
    "name": "agentRunStateSettleQuery",
    "operationKind": "query",
    "text": "query agentRunStateSettleQuery(\n  $agentId: String!\n  $runId: ID!\n) {\n  viewer {\n    actualPersonId\n    agenticWorker(agentId: $agentId) {\n      activeRuns {\n        id\n        scopeKind\n        scopeRowType\n        scopeRowId\n        state\n        rows {\n          rowType\n          rowId\n        }\n      }\n      lastRun {\n        id\n        scopeKind\n        scopeRowType\n        scopeRowId\n        state\n        rows {\n          rowType\n          rowId\n        }\n        stateReason\n        foundDetail\n        finishedAt\n      }\n      waitingResults {\n        id\n        runId\n        rows {\n          rowType\n          rowId\n          project {\n            companyProjectId\n            customProjectId\n            name\n            projectColor\n            id\n          }\n        }\n        state\n        hidden\n        producedAt\n      }\n      run(id: $runId) {\n        id\n        scopeKind\n        scopeRowType\n        scopeRowId\n        state\n        rows {\n          rowType\n          rowId\n        }\n        stateReason\n        foundDetail\n        finishedAt\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d42b2d9d861340c6230455fccf4ae35a";

export default node;
